//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2026, new Date().getFullYear());

export const mockTypeAudit = [
  { ID: 1, Title: 'Внутренний' },
  { ID: 2, Title: 'Перекрёстный' },
];

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year - fromYear + 1, Title: String(year) });
  }
  return years;
}

const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return {
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const currentDate = getCurrentDate();

export const initialFilter5SAudit = {
  year: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
    search: '',
  },
  location5S: { selected: [], selectedIds: [], search: '' },
  department: { selected: [], selectedIds: [], search: '' },
  site: { selected: [], selectedIds: [], search: '' },
  area: { selected: [], selectedIds: [], search: '' },
  typeAudit: { selected: [], selectedIds: [], search: '' },
  auditor: { selected: [], selectedIds: [], search: '' },
  coAuditor: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpenFilter5SAudit = {
  year: false,
  location5S: false,
  department: false,
  site: false,
  area: false,
  typeAudit: false,
  auditor: false,
  coAuditor: false,
};

export const filterConfigFilter5SAudit = {
  year: {
    title: 'Год',
    hasSearch: false,
    searchPlaceholder: 'Поиск по году',
    options: years.map((item) => item.Title),
  },
  location5S: {
    title: 'Локация',
    hasSearch: false,
    searchPlaceholder: 'Поиск по локации',
    options: [],
  },
  department: {
    title: 'Отдел',
    hasSearch: false,
    searchPlaceholder: 'Поиск по отделу',
    options: [],
  },
  site: {
    title: 'Участок',
    hasSearch: true,
    searchPlaceholder: 'Поиск по участку',
    options: [],
  },
  area: {
    title: 'Зона',
    hasSearch: true,
    searchPlaceholder: 'Поиск по зоне',
    options: [],
  },
  typeAudit: {
    title: 'Тип аудита',
    hasSearch: false,
    searchPlaceholder: 'Поиск по типу аудита',
    options: mockTypeAudit.map((item) => item.Title),
  },
  auditor: {
    title: 'Аудитор',
    hasSearch: false,
    userSearch: true,
    options: [],
  },
  coAuditor: {
    title: 'Соаудитор',
    hasSearch: false,
    userSearch: true,
    options: [],
  },
};



